import React, { useEffect, useMemo, useState } from "react";

import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  RSelect,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import queryString from 'query-string';
import { useHistory, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { Button, Card } from "reactstrap";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import { weekDayNames } from "../../utils/Utils";
const VIEW_OPTONS = [
  {
    label: 'Xem nhóm theo công nhân',
    value: 'GROUP_BY_USER'
  },
  {
    label: 'Xem nhóm theo công việc',
    value: 'GROUP_BY_TASK'
  },
]

const ReportTask = () => {
  const location = useLocation();
  const searchParams = queryString.parse(location.search, { arrayFormat: 'bracket' })
  const [data, setData] = useState({
    taskCategories: {},
    users: {},
    groupByTask: {},
    groupByUser: {}
  });
  const history = useHistory();
  const [smOption, setSmOption] = useState(false);
  const [taskCategoryOptions, setTaskCategoryOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [view, setView] = useState(searchParams?.view || VIEW_OPTONS[0].value)
  const [loading, setLoading] = useState(false)

  const [filter, setFilter] = useState({
    monthYear: searchParams?.monthYear || moment().format("YYYY-MM"),
    userId: searchParams?.userId?.map(Number) || [],
    taskCategoryId: searchParams?.taskCategoryId?.map(Number) || [],
  });


  useEffect(() => {

    GET(`/task-categories`, {}, true)
      .then(({ data }) => {
        setTaskCategoryOptions(data?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        ) || []);
      })

    GET("/user/list-workers", {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });
  }, []);

  const newParams = useMemo(() => {
    const { monthYear, taskCategoryId, userId } = filter;
    const newParams = queryString.stringify({
      monthYear,
      ...(taskCategoryId?.length > 0 ? { taskCategoryId } : {}),
      ...(userId?.length > 0 ? { userId } : {}),
      view,
    }, { arrayFormat: 'bracket' });

    return newParams
  }, [view, filter])
  useEffect(() => {
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });
  }, [newParams])

  useEffect(() => {
    setLoading(false)
    const { monthYear, taskCategoryId, userId } = filter;
    GET(
      "/employee-working-task/report",
      {
        monthYear,
        ...(taskCategoryId?.length > 0 ? { taskCategoryId } : {}),
        ...(userId?.length > 0 ? { userId } : {}),
        view,
      },
      true
    ).then((resp) => {
      const { data } = resp;
      setData(data);
    })
      .finally(() => {
        setLoading(false)
      })
  }, [filter]);

  const colTable = useMemo(() => {
    const startDate = moment(filter.monthYear, "YYYY-MM").startOf("months");
    const endDate = moment(filter.monthYear, "YYYY-MM").endOf("months");
    const cols = [
      ...(view === 'GROUP_BY_USER' ? [
        {
          Header: "Công việc",
          accessor: ([taskCategoryId]) => <div style={{ width: 220, textOverflow: 'hidden' }}>{data.taskCategories[taskCategoryId]}</div>,
          sticky: "left",
        },
      ] : [

        {
          Header: "Nhân viên",
          accessor: ([userId]) => <div style={{ width: 220, textOverflow: 'hidden' }}>{data.users[userId]}</div>,
          sticky: "left",
        },
      ])


    ]
    for (let i = 0; i < endDate.date(); i++) {
      const mmTempDate = startDate.clone().add(i, "days");
      const mmTempDateFormatFull = mmTempDate.format('YYYY-MM-DD');

      cols.push({
        Header: `${mmTempDate.format("DD")}(${weekDayNames[mmTempDate.day()]})`,
        accessor: ([id, item]) => <div className={view === 'GROUP_BY_USER' && Math.abs((data.taskCategories[id]?.total?.[mmTempDateFormatFull] || 0) - (data.taskCategories[id]?.compareTotalWorkingHour?.[mmTempDateFormatFull] || 0)) > 0 ? 'text-danger' : ''}>
          {item?.[mmTempDateFormatFull]}
        </div>
      })
    }
    return cols
  }, [filter, data, view])

  const renderGroupByUser = () => {
    return <div className="">
      {
        Object.entries(data.users || {}).filter(([id]) => !['compareTotalWorkingHour', 'total'].includes(id)).map(([id, name]) =>
          <Card key={id} className="mb-2">
            <h5>
              Nhân viên: {name}
            </h5>
            <Table
              style={{ minHeight: 'unset !important' }}
              loading={loading}
              columns={colTable}
              data={data.groupByUser[id] || []}
              notShowPagi
            ></Table>
          </Card>

        )
      }

    </div>
  }

  const renderGroupByTask = () => {
    return <div className="">
      {
        Object.entries(data.taskCategories || {}).filter(([id]) => !['compareTotalWorkingHour', 'total'].includes(id)).map(([id, name]) =>
          <Card key={id} className="mb-2">
            <h5>
              Công việc: {name}
            </h5>
            <Table
              style={{ minHeight: 'unset !important' }}
              loading={loading}
              columns={colTable}
              data={data.groupByTask[id] || []}
              notShowPagi
            ></Table>
          </Card>

        )
      }

    </div>
  }

  const exportExcel = () => {
    const url = `${process.env.REACT_APP_API_URL
      }/api/v1/employee-working-task/report-excel?${newParams.toString()}&token=${getToken()}`;
    window.open(url, "_blank");
  };

  return (
    <React.Fragment>
      <Head title="Bảng báo cáo công việc"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Bảng báo cáo công việc</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 220 }}>
                        <RSelect
                          options={VIEW_OPTONS}
                          value={VIEW_OPTONS.find((c) => c.value === view)}
                          onChange={(val) => setView(val.value)}
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          isMulti
                          placeholder="Lọc công việc"
                          classNamePrefix="form-control"
                          options={taskCategoryOptions}
                          value={taskCategoryOptions.filter(
                            (c) => filter.taskCategoryId?.includes(c.value)
                          )}
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              taskCategoryId: val?.map(e => e.value) || []
                            })
                          }

                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          isMulti
                          placeholder="Lọc công nhân"
                          classNamePrefix="form-control"
                          options={userOptions}
                          value={userOptions.filter(
                            (c) => filter.userId?.includes(c.value)
                          )}
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              userId: val?.map(e => e.value) || []
                            })
                          }

                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button color="secondary" onClick={exportExcel}>
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  {view === 'GROUP_BY_USER' ? renderGroupByUser() : renderGroupByTask()}
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default ReportTask;
